import { ADD_GROUP, SELECT_GROUP_PROPERTY, REMOVE_GROUP, RESET_GROUPS, SET_GROUPS } from './constants';
export var resetGroups = function resetGroups() {
  return {
    type: RESET_GROUPS
  };
};
export var addGroup = function addGroup(property) {
  return {
    type: ADD_GROUP,
    payload: {
      property: property
    }
  };
};
export var setGroups = function setGroups(groups) {
  return {
    type: SET_GROUPS,
    payload: {
      groups: groups
    }
  };
};
export var selectGroupProperty = function selectGroupProperty(id, property) {
  return {
    type: SELECT_GROUP_PROPERTY,
    payload: {
      id: id,
      property: property
    }
  };
};
export var removeGroup = function removeGroup(id) {
  return {
    type: REMOVE_GROUP,
    payload: {
      id: id
    }
  };
};